<template>
    <div id="RightAsideBar">
        <div v-b-toggle.sidebar-ToolBar>
            <img width="18" height="18" src="../assets/HandUp.png" />
        </div>
        <div v-b-toggle.DataSidebar @click="ChangeSideBarTab('EIPReservation')">
            <b-icon icon="pencil"></b-icon>
        </div>
    </div>
</template>
<style>
    #RightAsideBar {
        position: fixed;
        right: 0;
        top: 50%;
        padding:15px;
        transform: translateY(-50%) ;
        background: #23262B;
        box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.5);
        border-radius: 10px 0px 0px 10px;
        z-index:10
    }

        #RightAsideBar div:not(:last-child){
            margin-bottom:15px;
        }

        #RightAsideBar .b-sidebar {
            background: transparent !important;
        }
        #RightAsideBar .b-icon.bi {
            color: white !important;
            font-size: 18px !important;
        }
        
</style>
<script>
    export default {
        methods: {
            ChangeSideBarTab(tab) {
                this.$store.dispatch("handChangeSideBarTab",tab)
            },
        }
    }
</script>